import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import search_image from './undraw_search_app.svg';

interface Props {}

export const SearchWelcomeComponent = (props: Props) => {
    const { t } = useTranslation('common');

    return (
        <div className="tw-col-span-full tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-gap-16 tw-p-12 sm:tw-flex-col">
            <div>
                <h1 className="tw-font-bold tw-text-success">{t('search.welcomeTitle')}</h1>

                <h3 className="tw-mt-2">{t('search.welcomeSubtitle')}</h3>

                <p className="tw-m-0 tw-mt-4">{t('search.welcomeBody')}</p>
            </div>

            <Image src={search_image} alt="search_image_sportision" />
        </div>
    );
};
